import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import { useMeetingHubContext } from '../MeetingHubContext';
import Modal from 'components/shared/Modal';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import { ModalProps } from 'store/types/ComponentProps';
import { ActivityType } from 'store/enums/BallotReviewTypes';
import ActivityLogViewCard from './ActivityLogViewCard';

const ActivityLogModal: React.FunctionComponent<ModalProps> = ({ open, onClose }) => {
  const { activityLogs } = useMeetingHubContext();
  const displayLogs = useMemo(
    () => (activityLogs ?? []).filter((log) => log.type !== ActivityType.Connection),
    [activityLogs]
  );

  return (
    <Modal
      title={'Activity Logs'}
      open={open}
      onClose={onClose}
      onSubmit={onClose}
      maxWidth={'xl'}
      actions={
        <Button type="submit" color={'secondary'} variant={'outlined'}>
          Close
        </Button>
      }
    >
      <GridContainer>
        {displayLogs.map((log) => (
          <GridItem key={log.id}>
            <ActivityLogViewCard activityLog={log} />
          </GridItem>
        ))}
      </GridContainer>
    </Modal>
  );
};

export default ActivityLogModal;
